<template>
  <div class="sell-wraepper" :class="[leftGp ? 'left-gp':'']">
    <div class="text-sell" :class="[size == '20' ? 'font-size-20':'font-size-24']" @click="open" v-if="showLowStock == true">即将售罄</div>
    <div class="text-gray" :class="[size == '20' ? 'font-size-20':'font-size-24']" @click="open" v-if="outOfStock == true">已售罄</div>
    <!-- <div class="sell-wraepper-img" @click="open">!</div> -->
    <img :src="img + 'clicle-yellow11.png'" @click="open" class="sell-wraepper-img">

    <model-of-sell :visible.sync="bookingShow" :shorex="shorex" :showLowStock="showLowStock" :outOfStock="outOfStock"/>
  </div>
</template>

<script>
import ModelOfSell from './ModelOfSell.vue';
  export default {
    components: {
      ModelOfSell
    },

    props: {
      size: {
        type: String,
        default: '20'
      },
      shorex:{
        type: Boolean,
        default: false
      },
      showLowStock: {
        type: Boolean,
        default: false
      },
      outOfStock: {
        type: Boolean,
        default: false
      },
      leftGp: {
        type: Boolean,
        default: false
      },
    },

    data () {
      return {
        img:'https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/',
        bookingShow:false,
        isSellOver:false
      }
    },
    methods: {
      open() {
        console.log('open')
        this.bookingShow = true;
      }
    }
  }
</script>

<style lang="less" scoped>
  .sell-wraepper {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .sell-wraepper-img{
    width: 23px;
    height: 23px;
    margin-left: 6px;
    flex-shrink: 0;
    display: block;
  }
  .text-sell{
    color: #ff6600;
    font-size: 20px;
    font-weight: 500;
  }
  .text-gray{
    color: #a3a3a3;
    font-size: 20px;
    font-weight: 500;
  }

  .font-size-20{ 
    font-size: 20px !important;
  }
  .font-size-24{ 
    font-size: 24px !important;
  }

  .left-gp{
    margin-left: 14px;
  }
</style>